// Module
var code = `<div appHeaderBar>
    <header-bar-title>Make A Payment</header-bar-title>
</div>

<app-page-content [showWebFooter]="true" [usePagePadding]="true">
    <app-cobrand-header [property]="property.nickname" [manager]="property.hoa.pmc.name"
                        [association]="property.hoa.name" [makePayment]="true">
    </app-cobrand-header>

    <form name="propertyPaymentForm"
          tid="PropertyPaymentForm"
          id="propertyPaymentForm"
          #propertyPaymentForm="ngForm">
        <div class="HOA-misc-guidedSteps__container">
            <div class="HOA-misc-guidedSteps__header">
                <!-- TODO: Add the blue bar and the header formatting -->
                <div class="HOA-misc-guidedSteps__header-text">Select the Type of Payment You Want to Make</div>
            </div>
            <div class="HOA-misc-guidedSteps__flex HOA-misc-guidedSteps__flex-align HOA-misc-guidedSteps__flex-padded u-pB5">
                <button *ngIf="!property.stopHoldCode"
                        class="HOA-make-payment-option-link"
                        tid="oneTimePaymentLink"
                        id="oneTimePaymentLink"
                        type="button"
                        [ngClass]="{'HOA-make-payment-option-link-clicked': uiManipulation == UI.MAKE_PAYMENT}"
                        (click)="uiManipulation = UI.MAKE_PAYMENT; saveView();">
                    {{!uiManipulation || uiManipulation === UI.MAKE_PAYMENT ? '' : 'Switch to'}} One-Time
                    Payment
                </button>
                <span *ngIf="!property.stopHoldCode"
                      class="HOA-make-guidedSteps_middleColumn HOA-make-guidedSteps_middleColumn--small u-pV3">
                        or
                    </span>
                <button *ngIf="!property.stopHoldCode"
                        class="HOA-make-payment-option-link"
                        tid="schedulePaymentLink"
                        id="schedulePaymentLink"
                        type="button"
                        [ngClass]="{'HOA-make-payment-option-link-clicked': uiManipulation == UI.SCHEDULE_PAYMENT}"
                        (click)="uiManipulation = UI.SCHEDULE_PAYMENT; saveView();">
                    {{!uiManipulation || uiManipulation === UI.SCHEDULE_PAYMENT ? '' : 'Switch to'}} Schedule
                    Payments
                </button>
                <span *ngIf="availableAmenities && availableAmenities.length > 0 && !property.stopHoldCode"
                      class="HOA-make-guidedSteps_middleColumn HOA-make-guidedSteps_middleColumn--small u-pV3">
                    or
                </span>
                <button *ngIf="availableAmenities && availableAmenities.length > 0"
                        class="HOA-make-payment-option-link"
                        tid="amenityPaymentLink"
                        id="amenityPaymentLink"
                        type="button"
                        [ngClass]="{'HOA-make-payment-option-link-clicked': uiManipulation == UI.AMENITY_PAYMENT}"
                        (click)="uiManipulation = UI.AMENITY_PAYMENT; saveView();">
                    {{!uiManipulation || uiManipulation === UI.AMENITY_PAYMENT ? '' : 'Switch to'}} Amenity
                    Payment
                </button>
            </div>
        </div>

        <div *ngIf="uiManipulation">
            <!-- We show if make payment option is selected above-->
            <div class="HOA-misc-guidedSteps__container"
                 *ngIf="uiManipulation == UI.MAKE_PAYMENT || uiManipulation == UI.AMENITY_PAYMENT">
                <div class="HOA-misc-guidedSteps__header">
                    <!-- TODO: Add the blue bar and the header formatting -->
                    <div class="HOA-misc-guidedSteps__header-text">Enter Payment Information</div>
                </div>
                <div class="HOA-misc-guidedSteps__flex HOA-misc-guidedSteps__flex-align HOA-misc-guidedSteps__flex-padded u-pB5 u-fontGreenDark">
                    <span class="asterisk-required">&nbsp;&#42; All fields below are required</span>
                </div>
                <div class="HOA-misc-guidedSteps__flex HOA-misc-guidedSteps__flex-padded">
                    <div [ngClass]="{ 'is-invalid': paymentMethodError }"
                         class="Field HOA-misc-guidedSteps__flex-child HOA-make-payment-w100">
                        <label class="Field-label" for="paymentMethodNow">
                            Payment Method
                            <span class="asterisk-required">&nbsp;&#42;</span>
                            <a tid="addPaymentMethodNow" id="add" class="u-floatRight"
                               routerLink="/wallet"
                               [state]="{comingFromPayNow: true, propertyId: property.id, property: property}">
                                Add
                            </a>
                        </label>
                        <div class="Select">
                            <select tid="paymentMethodNow" id="paymentMethodNow" name="paymentMethodNow"
                                    [attr.aria-invalid]="paymentMethodError"
                                    [attr.aria-describedby]="paymentMethodError && 'paymentMethodNow-error' || undefined"
                                    [(ngModel)]="currentPaymentMethod"
                                    (change)="updatePaymentMethod()"
                                    [disabled]="paymentMethods && paymentMethods.length < 1">
                                <option *ngFor="let method of paymentMethods" [ngValue]="method">
                                    {{((method.nickname) ? method.nickname : method.line1) + ' (' + method.maskedId + ')'}}
                                <option>
                            </select>
                            <span class="Select-arrow"></span>
                        </div>
                        <span tid="paymentMethodNow-error"
                              id="paymentMethodNow-error"
                              class="Field-error">
                                {{paymentMethodErrorMsg ? paymentMethodErrorMsg : "Please select a payment method."}}
                            </span>
                        <span tid="paymentMethodNowMessage"
                              *ngIf="currentPaymentMethod && currentPaymentMethod.routingNumber"
                              class="HOA-Field-detail">
                                {{ACHMessage}}
                            </span>
                    </div>
                    <span class="HOA-make-guidedSteps_middleColumn"> </span>
                    <div class="Field HOA-misc-guidedSteps__flex-child">
                        <app-mat-date-picker
                                *ngIf="uiManipulation == UI.MAKE_PAYMENT"
                                [tidValue]="'paymentDate'"
                                [idValue]="'paymentDate'"
                                [labelText]="'Payment Date'"
                                [required]="true"
                                [config]="startDatePickerConfig"
                                (onDateChange)="startDateChange(\$event)">
                        </app-mat-date-picker>
                        <div *ngIf="uiManipulation == UI.AMENITY_PAYMENT"
                             class="pmt-date-container">
                            <label for="paymentDate" class="Field-label">
                                Payment Date
                                <span class="asterisk-required">&nbsp;*</span>
                            </label>
                            <div class="Field-addonBox">
                                <input type="text" [ngModel]="startDate ? startDate.format('MM/dd/yyyy') : startDate" name="paymentDateDisplay" maxlength="20"
                                       class="Input" style="height: 4.4rem; border-radius: 3px; border: 1px solid #d5d5d5; padding-left: 8px; font-size: 1.6rem;"
                                       id="paymentDate" tid="paymentDate" aria-required="false" disabled>
                            </div>
                        </div>
                        <span tid="paymentsNowProcessed" class="HOA-Field-detail">
                                Payments are processed Monday through Friday, excluding holidays.
                                Payments submitted on weekends or holidays may be delayed.
                            </span>
                    </div>
                </div>
            </div>

            <!-- We show if schedule payment option is selected above-->
            <div class="HOA-misc-guidedSteps__container" *ngIf="uiManipulation == UI.SCHEDULE_PAYMENT">
                <div class="HOA-misc-guidedSteps__header">
                    <div class="HOA-misc-guidedSteps__header-text">Enter Payment Information</div>
                </div>
                <div class="HOA-misc-guidedSteps__flex HOA-misc-guidedSteps__flex-align HOA-misc-guidedSteps__flex-padded u-pB5 u-fontGreenDark">
                    <span class="asterisk-required">&nbsp;&#42; All fields below are required</span>
                </div>
                <div class="HOA-misc-guidedSteps__flex HOA-misc-guidedSteps__flex-padded">
                    <div [ngClass]="{ 'is-invalid': false }"
                         class="Field HOA-misc-guidedSteps__flex-child HOA-make-payment-w100">
                        <label class="Field-label" for="paymentMethodScheduled"
                               routerLink="/wallet"
                               [state]="{comingFromPayNow: true, propertyId: property.id, property: property}">
                            Payment Method
                            <span class="asterisk-required">&nbsp;&#42;</span>
                            <a tid="addPaymentMethodScheduled" class="u-floatRight">Add</a>
                        </label>
                        <div class="Select">
                            <select id="paymentMethodScheduled"
                                    name="paymentMethodScheduled"
                                    tid="paymentMethodScheduled"
                                    [attr.aria-invalid]="paymentMethodError"
                                    [attr.aria-describedby]="paymentMethodError ? 'paymentMethodNow-error' : undefined"
                                    [(ngModel)]="currentPaymentMethod"
                                    (change)="updatePaymentMethod()"
                                    [disabled]="paymentMethods && paymentMethods.length < 1">
                                <option *ngFor="let paymentMethod of paymentMethods" [ngValue]="paymentMethod">
                                    {{((paymentMethod.nickname) ? paymentMethod.nickname : paymentMethod.line1) + ' (' + paymentMethod.maskedId + ')'}}
                                </option>
                            </select>
                            <span class="Select-arrow"></span>
                        </div>
                        <span id="paymentMethodScheduled-error"
                              tid="paymentMethodScheduled-error"
                              class="Field-error">
                                {{paymentMethodErrorMsg || "Please select a payment method."}}
                            </span>
                        <!-- TODO: Align the payment method description to the payment schedule description -->
                        <span tid="paymentMethodScheduledMessage" class="HOA-Field-detail">
                                {{ (currentPaymentMethod && currentPaymentMethod.routingNumber) ? ACHMessage : cardMessage }}
                            </span>
                    </div>
                    <span class="HOA-make-guidedSteps_middleColumn"> </span>
                    <div [ngClass]="{ 'is-invalid': false }" class="Field HOA-misc-guidedSteps__flex-child">
                        <label class="Field-label" for="scheduleFrequency">
                            Schedule Frequency
                            <span class="asterisk-required">&nbsp;&#42;</span>
                        </label>
                        <div class="Select">
                            <select tid="scheduleFrequency"
                                    id="scheduleFrequency"
                                    name="scheduleFrequency"
                                    [(ngModel)]="scheduleFrequency"
                                    (change)="updateScheduleFrequency()"
                                    [attr.aria-invalid]="false"
                                    [attr.aria-describedby]="'scheduleFrequency-error'">
                                <option *ngFor="let frequency of scheduleFrequencies"
                                        [ngValue]="frequency">{{frequency}}</option>
                            </select>
                            <span class="Select-arrow"></span>
                        </div>
                        <span tid="scheduleFrequency-error" id="scheduleFrequency-error" class="Field-error">
                                Please select a schedule frequency.
                            </span>
                    </div>
                </div>
                <div class="HOA-misc-guidedSteps__flex HOA-misc-guidedSteps__flex-padded">
                    <div class="Field HOA-misc-guidedSteps__flex-child">
                        <div class="HOA-flex-center-info-button">
                            <label class="Field-label" for="paymentScheduleType">
                                Schedule Type
                                <span class="asterisk-required">&nbsp;&#42;</span>
                            </label>
                            <button type="button"
                                    class="u-mL4 u-pB2 u-posRelative HOA-flex-center-info-button"
                                    (click)="scheduleTypeHelper()"
                                    tid="scheduleTypeHelper">
                                    <span class="Icon Icon--24 icon-utility-basics-question_circle-24 u-iconBlue background-image-none">
                                        <svg focusable="false"
                                             xmlns="http://www.w3.org/2000/svg"
                                             width="24"
                                             height="24"
                                             viewBox="0 0 72 72">
                                            <title>Schedule Type</title>
                                            <path class="stroke_layer"
                                                  d="M63.3 36a27 27 0 1 1-27-27 27 27 0 0 1 27 27z"
                                                  fill="none" stroke="#838383"
                                                  stroke-linecap="round"
                                                  stroke-linejoin="round"
                                                  stroke-width="3.8"></path>
                                            <path class="fill_layer"
                                                  d="M35.3 49.3a2 2 0 1 0 2 2 2 2 0 0 0-2-2z" fill="#838383"
                                                  stroke-width="3.8">
                                            </path>
                                            <path class="stroke_layer"
                                                  data-name="stroke_layer"
                                                  d="M29.2 25.8a8.4 8.4 0 0 1 2.4-4.8 6.5 6.5 0 0 1 4.8-1.8 8.5 8.5 0 0 1 2.7.4 6.2 6.2 0 0 1 2.2 1.3 5.9 5.9 0 0 1 1.4 2.1 7.4 7.4 0 0 1 .5 2.9 7.7 7.7 0 0 1-.2 2 6.5 6.5 0 0 1-.6 1.5l-.9 1.3-1.2 1.3-1.5 1.4a9.9 9.9 0 0 0-1.7 1.8 8.6 8.6 0 0 0-1 1.8 7.5 7.5 0 0 0-.5 1.8 12.3 12.3 0 0 0-.1 1.7v2.6"
                                                  fill="none"
                                                  stroke="#838383"
                                                  stroke-linecap="round"
                                                  stroke-linejoin="round"
                                                  stroke-width="3.8">
                                            </path>
                                        </svg>
                                    </span>
                            </button>
                        </div>
                        <div class="Select">
                            <select tid="paymentScheduleType"
                                    id="paymentScheduleType"
                                    name="paymentScheduleType"
                                    [(ngModel)]="currentPaymentScheduleType"
                                    (change)="updateScheduleType();"
                                    [attr.aria-invalid]="false"
                                    [attr.aria-describedby]="'paymentScheduleType-error'">
                                <option *ngFor="let x of paymentScheduleOptions"
                                        [ngValue]="x.value">
                                    {{x.display}}
                                </option>
                            </select>
                            <span class="Select-arrow"></span>
                        </div>
                    </div>
                    <span class="HOA-make-guidedSteps_middleColumn"> </span>
                    <div class="Field HOA-misc-guidedSteps__flex-child">
                        <div>
                            <div class="HOA-flex-center-info-button">
                                <label class="Field-label">
                                    Start Date
                                    <span class="asterisk-required">&nbsp;&#42;</span>
                                </label>
                                <button type="button"
                                        class="u-mL4 u-pB2 u-posRelative HOA-flex-center-info-button"
                                        (click)="startDateHelper()"
                                        tid="startDateHelper">
                                        <span class="Icon Icon--24 icon-utility-basics-question_circle-24 u-iconBlue background-image-none">
                                            <svg focusable="false"
                                                 xmlns="http://www.w3.org/2000/svg"
                                                 width="24"
                                                 height="24"
                                                 viewBox="0 0 72 72">
                                                <title>Start Date</title>
                                                <path class="stroke_layer"
                                                      d="M63.3 36a27 27 0 1 1-27-27 27 27 0 0 1 27 27z"
                                                      fill="none"
                                                      stroke="#838383"
                                                      stroke-linecap="round"
                                                      stroke-linejoin="round"
                                                      stroke-width="3.8">
                                                </path>
                                                <path class="fill_layer" d="M35.3 49.3a2 2 0 1 0 2 2 2 2 0 0 0-2-2z"
                                                      fill="#838383"
                                                      stroke-width="3.8">
                                                </path>
                                                <path class="stroke_layer"
                                                      data-name="stroke_layer"
                                                      d="M29.2 25.8a8.4 8.4 0 0 1 2.4-4.8 6.5 6.5 0 0 1 4.8-1.8 8.5 8.5 0 0 1 2.7.4 6.2 6.2 0 0 1 2.2 1.3 5.9 5.9 0 0 1 1.4 2.1 7.4 7.4 0 0 1 .5 2.9 7.7 7.7 0 0 1-.2 2 6.5 6.5 0 0 1-.6 1.5l-.9 1.3-1.2 1.3-1.5 1.4a9.9 9.9 0 0 0-1.7 1.8 8.6 8.6 0 0 0-1 1.8 7.5 7.5 0 0 0-.5 1.8 12.3 12.3 0 0 0-.1 1.7v2.6"
                                                      fill="none"
                                                      stroke="#838383"
                                                      stroke-linecap="round"
                                                      stroke-linejoin="round"
                                                      stroke-width="3.8">
                                                </path>
                                            </svg>
                                        </span>
                                </button>
                            </div>
                            <app-mat-date-picker
                                    [tidValue]="'scheduleStartDate'"
                                    [idValue]="'scheduleStartDate'"
                                    *ngIf="startDatePickerConfig && !isFixedDaySchedule()"
                                    [required]="true"
                                    [config]="startDatePickerConfig"
                                    (onDateChange)="startDateChange(\$event)">
                            </app-mat-date-picker>
                            <div *ngIf="isFixedDaySchedule()" class="Select">
                                <select tid="scheduleFixedDayStartDate"
                                        id="scheduleFixedDayStartDate"
                                        name="scheduleFixedDayStartDate"
                                        [(ngModel)]="scheduleFixedDayStartDate"
                                        (change)="updateScheduleFixedDayStartDate();"
                                        [attr.aria-invalid]="false"
                                        [attr.aria-describedby]="'scheduleFixedDayStartDate-error'">
                                    <option *ngFor="let scheduleFixedDayStartDate of scheduleFixedDayStartDates"
                                            [ngValue]="scheduleFixedDayStartDate">
                                        {{scheduleFixedDayStartDate.startDate.formattedFullDate}}
                                    </option>
                                </select>
                                <span class="Select-arrow"></span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="HOA-misc-guidedSteps__flex HOA-misc-guidedSteps__flex-padded">
                    <div [ngClass]="{ 'is-invalid': scheduleNameError }"
                         class="Field HOA-misc-guidedSteps__flex-child">
                        <div class="HOA-flex-center-info-button">
                            <label class="Field-label">
                                Schedule Name
                                <span class="asterisk-required">&nbsp;&#42;</span>
                            </label>
                            <button type="button"
                                    class="u-mL4 u-pB2 u-posRelative HOA-flex-center-info-button"
                                    (click)="scheduleNameHelper()"
                                    tid="scheduleTypeHelper">
                                    <span class="Icon Icon--24 icon-utility-basics-question_circle-24 u-iconBlue background-image-none">
                                        <svg focusable="false"
                                             xmlns="http://www.w3.org/2000/svg"
                                             width="24"
                                             height="24"
                                             viewBox="0 0 72 72">
                                            <title>Schedule Name</title>
                                            <path class="stroke_layer"
                                                  d="M63.3 36a27 27 0 1 1-27-27 27 27 0 0 1 27 27z"
                                                  fill="none"
                                                  stroke="#838383"
                                                  stroke-linecap="round"
                                                  stroke-linejoin="round"
                                                  stroke-width="3.8">
                                            </path>
                                            <path class="fill_layer" d="M35.3 49.3a2 2 0 1 0 2 2 2 2 0 0 0-2-2z"
                                                  fill="#838383"
                                                  stroke-width="3.8">
                                            </path>
                                            <path class="stroke_layer"
                                                  data-name="stroke_layer"
                                                  d="M29.2 25.8a8.4 8.4 0 0 1 2.4-4.8 6.5 6.5 0 0 1 4.8-1.8 8.5 8.5 0 0 1 2.7.4 6.2 6.2 0 0 1 2.2 1.3 5.9 5.9 0 0 1 1.4 2.1 7.4 7.4 0 0 1 .5 2.9 7.7 7.7 0 0 1-.2 2 6.5 6.5 0 0 1-.6 1.5l-.9 1.3-1.2 1.3-1.5 1.4a9.9 9.9 0 0 0-1.7 1.8 8.6 8.6 0 0 0-1 1.8 7.5 7.5 0 0 0-.5 1.8 12.3 12.3 0 0 0-.1 1.7v2.6"
                                                  fill="none"
                                                  stroke="#838383"
                                                  stroke-linecap="round"
                                                  stroke-linejoin="round"
                                                  stroke-width="3.8">
                                            </path>
                                        </svg>
                                    </span>
                            </button>
                        </div>
                        <input type="text"
                               class="Input"
                               tid="scheduleName"
                               id="scheduleName"
                               name="scheduleName"
                               maxlength="50"
                               (blur)="saveScheduleName()"
                               [(ngModel)]="scheduleName"
                               [attr.aria-invalid]="'scheduleNameError'"
                               [attr.aria-describedby]="scheduleNameError && 'scheduleName-error' || undefined"/>
                        <span tid="scheduleName-error" id="scheduleName-error" class="Field-error">
                                Please provide a valid name for this schedule.
                            </span>
                    </div>
                    <span class="HOA-make-guidedSteps_middleColumn"> </span>
                    <div [ngClass]="{ 'is-invalid': false }" class="Field HOA-misc-guidedSteps__flex-child">
                        <label class="Field-label" for="selectEndDate">
                            Select End Date
                            <span class="asterisk-required">&nbsp;&#42;</span>
                        </label>
                        <div class="Select">
                            <select tid="selectEndDate"
                                    id="selectEndDate"
                                    name="selectEndDate"
                                    [(ngModel)]="selectEndDate"
                                    [attr.aria-invalid]="false"
                                    [attr.aria-describedby]="'selectEndDate-error'">
                                <option>No End Date</option>
                                <option>Enter Number of Payments</option>
                                <!-- This shows/hides the end date picker and number of payments field-->
                            </select>
                            <span class="Select-arrow"></span>
                        </div>
                        <span tid="selectEndDate-error" id="selectEndDate-error" class="Field-error">
                                Please select a schedule end.
                            </span>
                    </div>
                </div>
                <div *ngIf="selectEndDate === 'Enter Number of Payments'"
                     class="HOA-misc-guidedSteps__flex HOA-misc-guidedSteps__flex-padded">
                    <div [ngClass]="{ 'is-invalid': (numberOfPayments > 18 || numberOfPayments < 1) }"
                         class="Field HOA-misc-guidedSteps__flex-child">
                        <label class="Field-label">Number of Payments
                            <span class="asterisk-required">&nbsp;&#42;</span>
                        </label>
                        <input type="text"
                               class="Input"
                               tid="numberOfPayments"
                               id="numberOfPayments"
                               name="numberOfPayments"
                               allow-pattern="\\d"
                               numbers-only
                               required
                               maxlength="2"
                               (change)="onChangeNumberOfPayments()"
                               [(ngModel)]="numberOfPaymentsInputValue"
                               [attr.aria-invalid]="(numberOfPayments > 18 || numberOfPayments < 1)"
                               [attr.aria-describedby]="(numberOfPayments > 18 || numberOfPayments < 1) && 'numberOfPayments-error' || undefined"/>
                        <span tid="numberOfPayments-error" id="numberOfPayments-error" class="Field-error">
                                Must be between 1 and 18 payments
                            </span>
                    </div>
                    <span class="HOA-make-guidedSteps_middleColumn">&nbsp;</span>
                    <div *ngIf="endDatePickerConfig" class="Field HOA-misc-guidedSteps__flex-child">
                        <app-mat-date-picker
                                [tidValue]="'scheduleEndDate'"
                                [idValue]="'scheduleEndDate'"
                                [labelText]="'End Date'"
                                [required]="true"
                                [config]="endDatePickerConfig"
                                (onDateChange)="endDateChange(\$event)">
                        </app-mat-date-picker>
                    </div>
                </div>
            </div>
            <app-select-amenities
                    *ngIf="availableAmenities && uiManipulation == UI.AMENITY_PAYMENT"
                    [property]="property"
                    [cartItems]="cartItems"
                    [itemsTotal]="+amountToPayInputValue"
                    [availableAmenities]="availableAmenities"
                    [availableCategories]="availableCategories"
                    [filteredAmenities]="availableAmenities"
                    [selectedCategory]="availableCategories[0]"
                    (onCartItemAdd)="addNewCartItem()">
            </app-select-amenities>
            <!--third box, what to pay-->
            <div class="HOA-misc-guidedSteps__container u-pB8">
                <div *ngIf="uiManipulation == UI.MAKE_PAYMENT || uiManipulation == UI.SCHEDULE_PAYMENT">
                    <div class="HOA-misc-guidedSteps__header">
                        <div class="HOA-flextable-component__flex-grow">
                            <div *ngIf = "currentPaymentScheduleType === 'fixed-amount'" class="HOA-misc-guidedSteps__header-text">Enter the Payment Amount</div>
                            <div *ngIf = "currentPaymentScheduleType === 'account-balance'" class="HOA-misc-guidedSteps__header-text">Account Balance Notice</div>
                        </div>
                    </div>
                    <div class="HOA-misc-guidedSteps__flex-padded">
                        <!--Hiding the balance summary
                        <app-property-line-item-details
                                [tid]="'PropertyLineItemDetails'"
                                [propertyId]="property.id">
                        </app-property-line-item-details>-->
                    </div>
                    <div class="HOA-misc-guidedSteps__flex-padded">
                        <div *ngIf="currentPaymentScheduleType !== 'account-balance'"
                             class="HOA-reset-payment-amount-link">
                            <a *ngIf="showResetAmountLink"
                               (click)="resetPaymentAmount()"
                               class="HOA-link"
                               tid="resettoamountdue">
                                Reset Original Amount
                            </a>
                        </div>
                        <div class="HOA-misc-guidedSteps__flex u-display-flow-root">
                            <div *ngIf="amountDue && amountDue !== 0">
                                <div class="HOA-flex-component">
                                        <span class="HOA-amount-due-display" tid="amountDueDisplay">
                                            Next Assessment Amount: {{amountDue | currency:"\$"}}
                                        </span>
                                </div>
                            </div>
                        </div>
                        <div class="HOA-misc-guidedSteps__flex">
                            <div class="HOA-flex-component HOA-misc-guidedSteps__flex-child u-pT3 u-justify-content-space-between">
                                <div class="HOA-flex-component"
                                     *ngIf="uiManipulation != UI.SCHEDULE_PAYMENT">
                                    <div class="HOA-flex-component HOA-make-payment-flex-align HOA-make-payment-fancy-width u-pT3">
                                        <!-- single row in dues -->
                                        <div class="HOA-make-payment-flex HOA-make-payment-item-row-details u-width-100p">
                                            <label>
                                                Amount
                                                <span class="asterisk-required">&nbsp;&#42;</span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                        <span *ngIf="currentPaymentScheduleType === 'account-balance' && uiManipulation == UI.SCHEDULE_PAYMENT"
                                              class="HOA-Field-detail">
                                            I agree to pay Scheduled Payment Amount including any administrative fees.
                                            I understand that the scheduled payment may not include any outstanding balance owed to the homeowner's association.
                                            I understand that the amount charged may vary if the assessment amount owed changes for future payments.
                                            By clicking here, I understand that I am responsible for any late fees, penalties, overdraft or other fees if my payment cannot be processed.<br><br>
                                        </span>
                                    <div class="HOA-flex-component u-pT3"
                                         *ngIf="currentPaymentScheduleType === 'fixed-amount' && uiManipulation == UI.SCHEDULE_PAYMENT">
                                        Enter Payment Amount
                                        <span class="asterisk-required">&nbsp;&#42;</span>
                                    </div>
                                </div>
                                <div [ngClass]="{ 'is-invalid': amountToPayErrorMsg}"
                                     class="Field u-cf HOA-make-payment-item-row-amount"
                                     *ngIf="currentPaymentScheduleType === 'fixed-amount' || uiManipulation == UI.MAKE_PAYMENT">
                                    <div class="Field-addonBox ">
                                        <input tid="amount1"
                                               id="amount1"
                                               name="amount1"
                                               type="text"
                                               class="Input"
                                               [(ngModel)]="amountToPayInputValue"
                                               (focus)="clearAmountFieldWhen0()"
                                               (change)="updateAmount()"
                                               [attr.aria-describedby]="amountToPayErrorMsg && 'amount1-error' || undefined"
                                               [attr.aria-invalid]="!!amountToPayErrorMsg"
                                               maxlength="9"
                                               custom-currency
                                        />
                                        <button type="button"
                                                class="Field-addon"
                                                (click)="clearAmount()"
                                                [attr.aria-label]="'Click to clear payment amount'">
                                            &times;
                                        </button>
                                    </div>
                                    <span tid="amount1-error"
                                          id="amount1-error"
                                          class="Field-error">
                                            {{amountToPayErrorMsg}}
                                        </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="HOA-misc-guidedSteps__flex-padded">
                    <app-select-amenities-cart *ngIf="uiManipulation == UI.AMENITY_PAYMENT"
                                               [cartItems]="cartItems"
                                               [itemsTotal]="+amountToPayInputValue"
                                               [property]="property"
                                               (onCartItemUpdate)="updateCartItem()">
                    </app-select-amenities-cart>
                    <div *ngIf="!(uiManipulation == UI.SCHEDULE_PAYMENT && currentPaymentScheduleType === 'account-balance')">
						<!--Order Total-->
						<div *ngIf="uiManipulation == UI.AMENITY_PAYMENT">
							<div class="HOA-flex-component HOA-make-payment-item-row-p25">
								<div class="u-cf HOA-flex-component">Order Total</div>
								<div tid="amountToPayInputValue"
								 	 id="amountToPayInputValue"
								 	class="Field-addonBox HOA-make-payment-item-row-amount u-textCenter">
									<span>{{amountToPayInputValue || 0 | currency}}</span>
						   	   </div>
						   </div>
						   <div *ngIf="amenityTotalErrorMsg" class="HOA-flex-component HOA-make-payment-item-row-p25 Field-error">
													{{amenityTotalErrorMsg}}
						   </div>
						</div>
                        <!--Administrative fee-->
                        <div class="HOA-flex-component HOA-make-payment-item-row-p25">
                            <div class="u-cf HOA-flex-component">Administrative Fee</div>
                            <div tid="convenienceFee"
                                 id="convenienceFee"
                                 class="Field-addonBox HOA-make-payment-item-row-amount u-textCenter">
                                <span>{{convenienceFee | currency}}</span>
                            </div>
                        </div>
                        <!--Amount to be paid-->
						<div *ngIf="uiManipulation == UI.AMENITY_PAYMENT">
							<div class="HOA-flex-component HOA-make-payment-item-row-p25">
								<div class="u-cf HOA-flex-component">Amount to be paid</div>
								<div class="Field-addonBox HOA-make-payment-item-row-amount u-textCenter">
									<span tid="totalAmount"
										  id="totalAmount"
										  class="HOA-make-payment-amount-owed">
										{{totalAmount || 0 | currency}}
									</span>
								</div>
							</div>
						</div>
						<div *ngIf="!(uiManipulation == UI.AMENITY_PAYMENT)">					
	                        <div class="HOA-flex-component HOA-make-payment-item-row-p25">
	                            <div class="u-cf HOA-flex-component">Amount to be paid</div>
	                            <div class="Field-addonBox HOA-make-payment-item-row-amount u-textCenter">
	                                <span tid="totalAmount"
	                                      id="totalAmount"
	                                      class="HOA-make-payment-amount-owed">
	                                    {{amountToPayErrorMsg ? 0 : totalAmount || 0 | currency}}
	                                </span>
	                            </div>
	                       </div>
                        </div>
                    </div>
					<div class="u-pT4 HOA-flex-component HOA-flextable-component__flex-end">
                        <button name="cancel"
                                id="cancel"
                                tid="cancel"
                                type="button"
                                class="Button Button--link HOA-make-payment-button"
                                routerLink="/properties">
                            Cancel
                        </button>
                        <button name="submit"
                                id="submit"
                                tid="submit"
                                type="submit"
                                [disabled]="propertyPaymentForm.invalid || submitDisabled()"
                                class="Button Button--blue HOA-make-payment-button"
                                ifOverFlowXClass="Button--overflowX"
                                (click)="affirmativeActionButton()">
                            Continue
                        </button>
                    </div>
                <div class="u-pT2 HOA-flex-component HOA-font-fine-print"><span class="asterisk-required">&#42;</span>&nbsp;Indicates
                        required field
                    </div>
                </div>
                </div>
        </div>
    </form>
</app-page-content>
`;
// Exports
module.exports = code;